import { render } from "./GroupTerm.vue?vue&type=template&id=4034fabb&scoped=true"
import script from "./GroupTerm.vue?vue&type=script&lang=js"
export * from "./GroupTerm.vue?vue&type=script&lang=js"

import "./GroupTerm.vue?vue&type=style&index=0&id=4034fabb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4034fabb"]])

export default __exports__